import React, { PureComponent } from 'react';
import { Select } from 'lego-on-react';
import b from 'b_';

import './year-filter.css';

interface Props {
    size?: 's' | 'l';
    years: number[];
    selectedYear?: string;
    onYearChange: any;
}

const class_ = b.with('year-filter');
const noValuePlaceholder = 'Any time';

export default class YearFilter extends PureComponent<Props> {
    public readonly state = {
        selectedYear: noValuePlaceholder
    };

    public onChange = (values: string[]) => {
        const [value] = values;

        this.setState({ selectedYear: value || noValuePlaceholder });

        this.props.onYearChange(value !== noValuePlaceholder ? value : undefined);
    };

    public render() {
        const { selectedYear = '', years: propsYears, size = 's' } = this.props;
        const years = [noValuePlaceholder, ...propsYears];

        return (
            <div className={class_({ size })}>
                <Select
                    cls={class_('select')}
                    val={+selectedYear || noValuePlaceholder}
                    theme="normal"
                    type="radio"
                    size="xs"
                    onChange={this.onChange}
                >
                    {years.map((year: any) => (
                        <Select.Item
                            key={year}
                            val={year}
                        >
                            {year}
                        </Select.Item>
                    ))}
                </Select>
            </div>
        );
    }
}
